import { useState, useEffect, useCallback } from "react";
import Modal from "../../components/Modal";
import Topbar from "../../components/Topbar";
import api from "../../services/api";

const CATEGORIAS = [
  { key: "TODOS",      label: "Todos" },
  { key: "CONSUMIDOR", label: "Consumidor Final" },
  { key: "ARQ_ENG",    label: "Arq / Eng" },
  { key: "REVENDEDOR", label: "Revendedor" },
  { key: "LOJISTA",    label: "Lojista" },
  { key: "ATACADISTA", label: "Atacadista" },
  { key: "PROSPECCAO", label: "Prospeccao" },
  { key: "FORNECEDOR", label: "Fornecedor" },
];
const CAT_BADGE = { CONSUMIDOR:"badge-gray", ARQ_ENG:"badge-blue", REVENDEDOR:"badge-amber", LOJISTA:"badge-amber", ATACADISTA:"badge-amber", PROSPECCAO:"badge-gray", FORNECEDOR:"badge-blue" };
const STA_BADGE = { ATIVO:"badge-green", INATIVO:"badge-gray", BLOQUEADO:"badge-red" };

const VAZIO_END = { tipo:"COBRANCA", logradouro:"", numero:"", complemento:"", bairro:"", cidade:"", estado:"", cep:"", principal:true, latitude:"", longitude:"" };
const VAZIO = { nome:"", razao_social:"", tipo:"PF", categoria:"CONSUMIDOR", cpf:"", cnpj:"", inscricao_estadual:"", email:"", status:"ATIVO", observacoes:"" };

function endPrincipal(contato) {
  const e = (contato.enderecos||[]).find(x=>x.principal) || (contato.enderecos||[])[0];
  if (!e) return "-";
  return `${e.logradouro}, ${e.numero}${e.cidade ? ", "+e.cidade : ""}${e.estado ? "/"+e.estado : ""}`;
}
function telPrincipal(contato) {
  const t = (contato.telefones||[]).find(x=>x.principal) || (contato.telefones||[])[0];
  return t ? t.numero : "-";
}





function LinhaContato({contato, onSalvo, onExcluir, buscarCNPJ, buscarCEP, geocodificar}){
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({...contato});
  const [endForm, setEndForm] = useState(
    (contato.enderecos||[])[0] || {tipo:"COBRANCA",logradouro:"",numero:"",complemento:"",bairro:"",cidade:"",estado:"",cep:"",principal:true}
  );
  const [salvando, setSalvando] = useState(false);
  const [buscandoCNPJ, setBuscandoCNPJ] = useState(false);
  const [buscandoCEP, setBuscandoCEP] = useState(false);
  const [geocodificando, setGeocodificando] = useState(false);

  const setF = (f,v) => setForm(prev=>({...prev,[f]:v}));
  const setE = (f,v) => setEndForm(prev=>({...prev,[f]:v}));

  const handleCNPJ = async (val) => {
    setF("cnpj", val);
    const nums = val.replace(/\D/g,"");
    if(nums.length !== 14) return;
    setBuscandoCNPJ(true);
    try{
      const res = await fetch("https://publica.cnpj.ws/cnpj/"+nums);
      if(!res.ok) return;
      const d = await res.json();
      const razao = d.razao_social||d.nome||"";
      const fantasia = d.estabelecimento?.nome_fantasia||d.nome_fantasia||"";
      const email = d.estabelecimento?.email||d.email||"";
      setForm(f=>({...f, nome:fantasia||razao||f.nome, razao_social:razao||"", email:email||f.email||""}));
      const est = d.estabelecimento;
      if(est && est.cep){
        const cep = est.cep.replace(/\D/g,"");
        setEndForm(prev=>({...prev, cep, logradouro:est.logradouro||"", numero:est.numero||"", bairro:est.bairro?.nome||"", cidade:est.municipio?.descricao||"", estado:est.estado?.sigla||""}));
      }
    }catch{}
    finally{setBuscandoCNPJ(false);}
  };

  const handleCEP = async (val) => {
    setE("cep", val);
    const nums = val.replace(/\D/g,"");
    if(nums.length !== 8) return;
    setBuscandoCEP(true);
    try{
      const res = await fetch("https://viacep.com.br/ws/"+nums+"/json/");
      const d = await res.json();
      if(!d.erro) setEndForm(prev=>({...prev, logradouro:d.logradouro||"", bairro:d.bairro||"", cidade:d.localidade||"", estado:d.uf||""}));
    }catch{}
    finally{setBuscandoCEP(false);}
  };

  const handleGeo = async () => {
    setGeocodificando(true);
    try{
      const addr = endForm.logradouro+", "+endForm.numero+", "+endForm.cidade+", "+endForm.estado;
      const res = await fetch("https://nominatim.openstreetmap.org/search?format=json&q="+encodeURIComponent(addr));
      const d = await res.json();
      if(d[0]) setEndForm(prev=>({...prev, latitude:d[0].lat, longitude:d[0].lon}));
    }catch{}
    finally{setGeocodificando(false);}
  };

  const salvar = async (e) => {
    e.stopPropagation();
    setSalvando(true);
    try{
      await api.put("/clientes/contatos/"+contato.id+"/", form);
      if(endForm.logradouro){
        const endExist = (contato.enderecos||[])[0];
        if(endExist) await api.put("/clientes/enderecos/"+endExist.id+"/", {...endForm, contato:contato.id});
        else await api.post("/clientes/enderecos/", {...endForm, contato:contato.id});
      }
      onSalvo();
      setOpen(false);
    }catch{alert("Erro ao salvar.");}
    finally{setSalvando(false);}
  };

  const catLabel = CATEGORIAS.find(x=>x.key===contato.categoria)?.label||contato.categoria;
  const catBadge = "badge " + (CAT_BADGE[contato.categoria]||"badge-gray");
  const staBadge = "badge " + (STA_BADGE[contato.status]||"badge-gray");

  return(
    <>
      <tr className="tr-expandable" onClick={()=>setOpen(o=>!o)}>
        <td>
          <strong>{contato.nome}</strong>
          {contato.razao_social&&<div style={{fontSize:11,color:"var(--z-text-secondary)"}}>{contato.razao_social}</div>}
          {(contato.cnpj||contato.cpf)&&<div style={{fontSize:11,color:"var(--z-text-muted)"}}>{contato.cnpj||contato.cpf}</div>}
        </td>
        <td><span className={catBadge}>{catLabel}</span></td>
        <td><span className="badge badge-gray">{contato.tipo}</span></td>
        <td style={{color:"var(--z-text-secondary)",fontSize:12}}>{telPrincipal(contato)}</td>
        <td style={{color:"var(--z-text-secondary)",fontSize:12,maxWidth:200}}>{endPrincipal(contato)}</td>
        <td style={{color:"var(--z-text-secondary)",fontSize:12}}>{contato.email||"-"}</td>
        <td><span className={staBadge}>{contato.status}</span></td>
        <td style={{textAlign:"right"}}><i className={"ti ti-chevron-"+(open?"up":"down")} style={{fontSize:14,color:"var(--z-text-muted)"}}/></td>
      </tr>
      {open&&(
        <tr className="tr-dropdown">
          <td colSpan={8}>
            <div className="dropdown-content" onClick={e=>e.stopPropagation()}>
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:8}}>
                <div className="form-group">
                  <label className="form-label">Tipo</label>
                  <select className="form-select" value={form.tipo||"PF"} onChange={e=>setF("tipo",e.target.value)}>
                    <option value="PF">Pessoa Fisica</option>
                    <option value="PJ">Pessoa Juridica</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Categoria</label>
                  <select className="form-select" value={form.categoria||""} onChange={e=>setF("categoria",e.target.value)}>
                    {CATEGORIAS.filter(c=>c.key!=="TODOS").map(c=><option key={c.key} value={c.key}>{c.label}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Status</label>
                  <select className="form-select" value={form.status||"ATIVO"} onChange={e=>setF("status",e.target.value)}>
                    <option value="ATIVO">Ativo</option>
                    <option value="INATIVO">Inativo</option>
                    <option value="BLOQUEADO">Bloqueado</option>
                  </select>
                </div>
                {form.tipo==="PJ"?(
                  <div className="form-group">
                    <label className="form-label">CNPJ {buscandoCNPJ&&<span style={{fontSize:11,color:"var(--z-blue)",marginLeft:8}}>Buscando...</span>}</label>
                    <input className="form-input" value={form.cnpj||""} placeholder="00.000.000/0000-00" onChange={e=>handleCNPJ(e.target.value)}/>
                  </div>
                ):(
                  <div className="form-group">
                    <label className="form-label">CPF</label>
                    <input className="form-input" value={form.cpf||""} placeholder="000.000.000-00" onChange={e=>setF("cpf",e.target.value)}/>
                  </div>
                )}
                <div className="form-group" style={{gridColumn:"span 2"}}>
                  <label className="form-label">Nome</label>
                  <input className="form-input" value={form.nome||""} onChange={e=>setF("nome",e.target.value)}/>
                </div>
                {form.tipo==="PJ"&&<div className="form-group" style={{gridColumn:"span 2"}}><label className="form-label">Razao social</label><input className="form-input" value={form.razao_social||""} onChange={e=>setF("razao_social",e.target.value)}/></div>}
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input className="form-input" type="email" value={form.email||""} onChange={e=>setF("email",e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Insc. Estadual</label>
                  <input className="form-input" value={form.inscricao_estadual||""} onChange={e=>setF("inscricao_estadual",e.target.value)}/>
                </div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:8}}>
                <div className="form-group">
                  <label className="form-label">Tipo endereco</label>
                  <select className="form-select" value={endForm.tipo||"COBRANCA"} onChange={e=>setE("tipo",e.target.value)}>
                    <option value="COBRANCA">Cobranca</option>
                    <option value="ENTREGA">Entrega</option>
                    <option value="SERVICO">Servico</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">CEP {buscandoCEP&&<span style={{fontSize:11,color:"var(--z-blue)",marginLeft:6}}>buscando...</span>}</label>
                  <input className="form-input" value={endForm.cep||""} placeholder="00000-000" onChange={e=>handleCEP(e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Numero</label>
                  <input className="form-input" value={endForm.numero||""} onChange={e=>setE("numero",e.target.value)}/>
                </div>
                <div className="form-group" style={{gridColumn:"span 2"}}>
                  <label className="form-label">Logradouro</label>
                  <input className="form-input" value={endForm.logradouro||""} onChange={e=>setE("logradouro",e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Complemento</label>
                  <input className="form-input" value={endForm.complemento||""} onChange={e=>setE("complemento",e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Bairro</label>
                  <input className="form-input" value={endForm.bairro||""} onChange={e=>setE("bairro",e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Cidade</label>
                  <input className="form-input" value={endForm.cidade||""} onChange={e=>setE("cidade",e.target.value)}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Estado</label>
                  <input className="form-input" value={endForm.estado||""} onChange={e=>setE("estado",e.target.value)}/>
                </div>
                <div className="form-group" style={{display:"flex",alignItems:"flex-end",gap:8}}>
                  <button className="btn btn-secondary" onClick={handleGeo}>
                    <i className="ti ti-map-pin"/> Buscar coordenadas
                  </button>
                  {endForm.latitude&&<span style={{fontSize:12,color:"var(--z-success-text)"}}>{parseFloat(endForm.latitude).toFixed(4)}, {parseFloat(endForm.longitude).toFixed(4)}</span>}
                </div>
              </div>
              <div className="form-group" style={{gridColumn:"span 4",marginBottom:0}}>
                <textarea className="form-input" rows={1} value={form.observacoes||""} onChange={e=>setF("observacoes",e.target.value)}/>
              </div>
              <div className="produto-dropdown-acoes">
                <button className="btn btn-primary" disabled={salvando} onClick={salvar}>
                  <i className="ti ti-check"/> {salvando?"Salvando...":"Salvar"}
                </button>
                <button className="btn btn-danger" onClick={e=>{e.stopPropagation();onExcluir(contato.id);}}>
                  <i className="ti ti-trash"/> Excluir
                </button>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

export default function ClientesLista() {
  const [contatos, setContatos]     = useState([]);
  const [busca, setBusca]           = useState("");
  const [aba, setAba]               = useState("TODOS");
  const [loading, setLoading]       = useState(true);
  const [modalVer, setModalVer]     = useState(null);
  const [modalForm, setModalForm]   = useState(null);
  const [form, setForm]             = useState(VAZIO);
  const [endForm, setEndForm]       = useState(VAZIO_END);
  const [salvando, setSalvando]     = useState(false);
  const [buscandoCNPJ, setBuscandoCNPJ] = useState(false);
  const [buscandoCEP, setBuscandoCEP]   = useState(false);
  const [geocodificando, setGeocodificando] = useState(false);

  const carregar = () => {
    setLoading(true);
    api.get("/clientes/contatos/?page_size=1000")
      .then(res => setContatos(res.data.results || res.data))
      .catch(() => setContatos([]))
      .finally(() => setLoading(false));
  };
  useEffect(()=>{carregar();},[]);

  const filtrados = contatos
    .filter(c => aba === "TODOS" ? c.categoria !== "FORNECEDOR" : c.categoria === aba)
    .filter(c => c.nome.toLowerCase().includes(busca.toLowerCase()) ||
      (c.email||"").toLowerCase().includes(busca.toLowerCase()) ||
      (c.cnpj||"").includes(busca) || (c.cpf||"").includes(busca));

  const count = (key) => key === "TODOS" ? contatos.filter(c=>c.categoria!=="FORNECEDOR").length : contatos.filter(c=>c.categoria===key).length;

  // Busca CNPJ automaticamente — com debounce
  const buscarCNPJ = async (cnpj) => {
    const nums = cnpj.replace(/\D/g,"");
    if(nums.length !== 14) return;
    await new Promise(r=>setTimeout(r,500));
    setBuscandoCNPJ(true);
    try {
      const res = await fetch(`https://publica.cnpj.ws/cnpj/${nums}`);
      if(!res.ok) return;
      const d = await res.json();      const razao = d.razao_social||d.nome||"";
      const fantasia = d.estabelecimento?.nome_fantasia||d.nome_fantasia||"";
      const email = d.estabelecimento?.email||d.email||"";
      setForm(f=>({
        ...f,
        nome: fantasia||razao||f.nome,
        razao_social: razao||"",
        email: email||f.email||"",
      }));
      // Preenche endereco se existir
      const est = d.estabelecimento;
      if(est){
        const cep = (est.cep||"").replace(/\D/g,"");
        setEndForm(e=>({
          ...e,
          logradouro: `${est.tipo_logradouro||""} ${est.logradouro||""}`.trim(),
          numero: est.numero||"",
          complemento: est.complemento||"",
          bairro: est.bairro||"",
          cidade: est.cidade?.ibge_nome||est.cidade?.nome||"",
          estado: est.estado?.sigla||"",
          cep: cep,
        }));
        // Geocodifica automaticamente
        if(est.logradouro && est.numero){
          geocodificarEndereco(`${est.tipo_logradouro} ${est.logradouro}, ${est.numero}, ${est.cidade?.ibge_nome||""}, ${est.estado?.sigla||""}, Brasil`);
        }
      }
    } catch(e){} finally { setBuscandoCNPJ(false); }
  };

  // Busca CEP automaticamente — com debounce
  const buscarCEP = async (cep) => {
    const nums = cep.replace(/\D/g,"");
    if(nums.length !== 8) return;
    await new Promise(r=>setTimeout(r,300));
    setBuscandoCEP(true);
    try {
      const res = await fetch(`https://viacep.com.br/ws/${nums}/json/`);
      const d = await res.json();
      if(d.erro) return;
      setEndForm(f=>({
        ...f,
        logradouro: d.logradouro||f.logradouro,
        bairro: d.bairro||f.bairro,
        cidade: d.localidade||f.cidade,
        estado: d.uf||f.estado,
      }));
    } catch(e){} finally { setBuscandoCEP(false); }
  };

  // Geocodifica endereco via Nominatim
  const geocodificarEndereco = async (endStr) => {
    if(!endStr) return;
    setGeocodificando(true);
    try {
      const q = encodeURIComponent(endStr);
      const res = await fetch(`https://nominatim.openstreetmap.org/search?q=${q}&format=json&limit=1`);
      const d = await res.json();
      if(d.length>0){
        setEndForm(f=>({...f, latitude:d[0].lat, longitude:d[0].lon}));
      }
    } catch(e){} finally { setGeocodificando(false); }
  };

  const geocodificarAtual = () => {
    const end = `${endForm.logradouro}, ${endForm.numero}, ${endForm.cidade}, ${endForm.estado}, Brasil`;
    geocodificarEndereco(end);
  };

  const abrirNovo = () => { setForm(VAZIO); setEndForm(VAZIO_END); setModalForm("novo"); };
  const abrirEditar = (c) => {
    setForm({...c});
    const e = (c.enderecos||[]).find(x=>x.principal)||(c.enderecos||[])[0];
    setEndForm(e ? {...e} : VAZIO_END);
    setModalForm("editar");
    setModalVer(null);
  };

  const salvar = async () => {
    setSalvando(true);
    try {
      let contato;
      if(modalForm==="novo"){
        const res = await api.post("/clientes/contatos/", form);
        contato = res.data;
      } else {
        const res = await api.put(`/clientes/contatos/${form.id}/`, form);
        contato = res.data;
      }
      // Salva endereco
      if(endForm.logradouro){
        const endData = {...endForm, contato: contato.id};
        const endExistente = (form.enderecos||[]).find(x=>x.principal)||(form.enderecos||[])[0];
        if(endExistente?.id){
          await api.put(`/clientes/enderecos/${endExistente.id}/`, endData);
        } else {
          await api.post("/clientes/enderecos/", endData);
        }
      }
      carregar();
      setModalForm(null);
    } catch(e){ alert("Erro ao salvar."); }
    finally { setSalvando(false); }
  };

  const excluir = async (id) => {
    if(!window.confirm("Excluir este contato?")) return;
    await api.delete(`/clientes/contatos/${id}/`);
    carregar();
    setModalVer(null);
  };

  const setF = (f,v) => setForm(prev=>({...prev,[f]:v}));
  const setE = (f,v) => setEndForm(prev=>({...prev,[f]:v}));

  return(
    <>
      <Topbar title="Clientes"/>
      <div className="erp-content">
        <div className="page-toolbar">
          <button className="btn btn-primary" onClick={abrirNovo}><i className="ti ti-plus"/> Novo contato</button>
          <input className="form-input" style={{width:240}} placeholder="Buscar..." value={busca} onChange={e=>setBusca(e.target.value)}/>
        </div>

        <div className="abas-wrapper" style={{marginBottom:16}}>
          <div className="abas">
            {CATEGORIAS.map(cat=>(
              <button key={cat.key} className={"aba"+(aba===cat.key?" aba-ativa":"")} onClick={()=>setAba(cat.key)}>
                {cat.label} <span className="aba-count">{count(cat.key)}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="card">
          <div className="table-wrapper">
            {loading?<div className="table-empty">Carregando...</div>:
            filtrados.length===0?<div className="table-empty">Nenhum contato encontrado.</div>:(
              <table>
                <thead><tr>
                  <th>Nome</th><th>Categoria</th><th>Tipo</th>
                  <th>Telefone</th><th>Endereco</th><th>Email</th><th>Status</th><th></th>
                </tr></thead>
                <tbody>
                  {filtrados.map(c=>(
                    <LinhaContato key={c.id} contato={c} onSalvo={carregar} onExcluir={excluir}/>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>

      

      {modalForm&&(
        <Modal title={modalForm==="novo"?"Novo contato":"Editar contato"} onClose={()=>setModalForm(null)} size="lg"
          footer={<>
            <button className="btn btn-secondary" onClick={()=>setModalForm(null)}>Cancelar</button>
            <button className="btn btn-primary" onClick={salvar} disabled={salvando}>{salvando?"Salvando...":"Salvar"}</button>
          </>}>

          <div className="form-section">Dados principais</div>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Tipo</label>
              <select className="form-select" value={form.tipo} onChange={e=>setF("tipo",e.target.value)}>
                <option value="PF">Pessoa Fisica</option>
                <option value="PJ">Pessoa Juridica</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Categoria</label>
              <select className="form-select" value={form.categoria} onChange={e=>setF("categoria",e.target.value)}>
                {CATEGORIAS.filter(c=>c.key!=="TODOS").map(c=><option key={c.key} value={c.key}>{c.label}</option>)}
              </select>
            </div>
            {form.tipo==="PJ"?(
              <div className="form-group" style={{gridColumn:"span 2"}}>
                <label className="form-label">
                  CNPJ
                  {buscandoCNPJ&&<span style={{fontSize:11,color:"var(--z-blue)",marginLeft:8}}>Buscando...</span>}
                </label>
                <input className="form-input" value={form.cnpj||""} placeholder="00.000.000/0000-00"
                  onChange={e=>{setF("cnpj",e.target.value); buscarCNPJ(e.target.value);}}/>
              </div>
            ):(
              <div className="form-group" style={{gridColumn:"span 2"}}>
                <label className="form-label">CPF</label>
                <input className="form-input" value={form.cpf||""} placeholder="000.000.000-00" onChange={e=>setF("cpf",e.target.value)}/>
              </div>
            )}
            <div className="form-group" style={{gridColumn:"span 2"}}>
              <label className="form-label">Nome {buscandoCNPJ&&<span style={{fontSize:11,color:"var(--z-blue)"}}>preenchido automaticamente</span>}</label>
              <input className="form-input" value={form.nome||""} onChange={e=>setF("nome",e.target.value)} placeholder="Nome ou razao social"/>
            </div>
            {form.tipo==="PJ"&&(
              <div className="form-group" style={{gridColumn:"span 2"}}>
                <label className="form-label">Razao social</label>
                <input className="form-input" value={form.razao_social||""} onChange={e=>setF("razao_social",e.target.value)}/>
              </div>
            )}
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input" type="email" value={form.email||""} onChange={e=>setF("email",e.target.value)}/>
            </div>
            <div className="form-group">
              <label className="form-label">Insc. Estadual</label>
              <input className="form-input" value={form.inscricao_estadual||""} onChange={e=>setF("inscricao_estadual",e.target.value)}/>
            </div>
            <div className="form-group">
              <label className="form-label">Status</label>
              <select className="form-select" value={form.status} onChange={e=>setF("status",e.target.value)}>
                <option value="ATIVO">Ativo</option>
                <option value="INATIVO">Inativo</option>
                <option value="BLOQUEADO">Bloqueado</option>
              </select>
            </div>
          </div>

          <div className="form-section">
            Endereco
            {buscandoCEP&&<span style={{fontSize:11,color:"var(--z-blue)",marginLeft:8}}>Buscando CEP...</span>}
            {geocodificando&&<span style={{fontSize:11,color:"var(--z-blue)",marginLeft:8}}>Geocodificando...</span>}
          </div>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Tipo endereco</label>
              <select className="form-select" value={endForm.tipo} onChange={e=>setE("tipo",e.target.value)}>
                <option value="COBRANCA">Cobranca</option>
                <option value="ENTREGA">Entrega</option>
                <option value="SERVICO">Servico</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">
                CEP
                {buscandoCEP&&<span style={{fontSize:11,color:"var(--z-blue)",marginLeft:6}}>buscando...</span>}
              </label>
              <input className="form-input" value={endForm.cep||""} placeholder="00000-000"
                onChange={e=>{setE("cep",e.target.value); buscarCEP(e.target.value);}}/>
            </div>
            <div className="form-group" style={{gridColumn:"span 2"}}>
              <label className="form-label">Logradouro</label>
              <input className="form-input" value={endForm.logradouro||""} onChange={e=>setE("logradouro",e.target.value)} placeholder="Rua, Avenida..."/>
            </div>
            <div className="form-group">
              <label className="form-label">Numero</label>
              <input className="form-input" value={endForm.numero||""} onChange={e=>setE("numero",e.target.value)}/>
            </div>
            <div className="form-group">
              <label className="form-label">Complemento</label>
              <input className="form-input" value={endForm.complemento||""} onChange={e=>setE("complemento",e.target.value)} placeholder="Apto, sala..."/>
            </div>
            <div className="form-group">
              <label className="form-label">Bairro</label>
              <input className="form-input" value={endForm.bairro||""} onChange={e=>setE("bairro",e.target.value)}/>
            </div>
            <div className="form-group">
              <label className="form-label">Cidade</label>
              <input className="form-input" value={endForm.cidade||""} onChange={e=>setE("cidade",e.target.value)}/>
            </div>
            <div className="form-group">
              <label className="form-label">Estado</label>
              <input className="form-input" value={endForm.estado||""} onChange={e=>setE("estado",e.target.value)} placeholder="SP"/>
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
            <button className="btn btn-secondary" style={{fontSize:12}} onClick={geocodificarAtual} disabled={geocodificando||!endForm.logradouro}>
              <i className="ti ti-map-pin"/> {geocodificando?"Buscando...":"Buscar coordenadas"}
            </button>
            {endForm.latitude&&(
              <span style={{fontSize:12,color:"var(--z-success-text)"}}>
                ✓ {parseFloat(endForm.latitude).toFixed(5)}, {parseFloat(endForm.longitude).toFixed(5)}
              </span>
            )}
          </div>

          <div className="form-section">Observacoes</div>
          <div className="form-group">
            <textarea className="form-input" rows={3} value={form.observacoes||""} onChange={e=>setF("observacoes",e.target.value)}/>
          </div>
        </Modal>
      )}
    </>
  );
}



